module.exports = __webpack_public_path__ + "img/24.938f903b.png";